import React from 'react';
import { Link } from 'react-router-dom'

import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import About from '../components/layouts/About';

import mission from '../assets/images/pages/our-mission.png'
import vission from '../assets/images/pages/our-vission.png'
import Action from '../components/layouts/Action';

import img from '../assets/images/items/group-ntf-03.png'

const Nosotros = () => {
    return (
        <div className='mission'>
            <Header />

            {/* Hero Section */}
            <section className="tf-section" style={{ paddingTop: '150px', paddingBottom: '60px', textAlign: 'center' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="block-text text-black center" style={{ marginBottom: '80px' }}>
                                <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>Nosotros</span></h1>
                                <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Rodex Hostel</h5>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 1: Que es Rodex Hostel */}
            <section className="tf-section section-about pt-0">
                <div className="container">
                    <div className="row reverse" style={{ alignItems: 'center' }}>
                        <div className="col-xl-6 col-md-12 mb-4 mb-xl-0">
                            <div className="group-image" data-aos="fade-right" data-aos-duration="1000">
                                <img src={mission} alt="Rodex Hostel" style={{ borderRadius: '20px', width: '100%', objectFit: 'cover', boxShadow: '0 15px 40px rgba(0,0,0,0.1)' }} />
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="block-text pt-0" style={{ paddingLeft: '30px' }} data-aos="fade-left" data-aos-duration="1000">
                                <h5 className="sub-title mb-20 text-black" style={{ fontSize: '50px' }}>¿Qué es Rodex Hostel?</h5>
                                <p className="fs-21 mb-33 text-black">Rodex Hostel es un espacio de alojamiento en San Miguel de Tucumán pensado para viajeros que buscan una opción accesible, cómoda y con buena energía. Aquí no solo encuentras un lugar para descansar, sino también la posibilidad de conocer gente, compartir experiencias y formar parte de una comunidad hostelera.</p>
                                <p className="fs-21 mb-33 text-black">Con un ambiente cálido y social, clases de yoga gratuitas y actividades todas las semanas, Rodex Hostel busca que cada huésped se lleve mucho más que una estadía: una experiencia auténtica.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: Nuestra Filosofia */}
            <section className="tf-section section-about" style={{ backgroundColor: 'rgba(0,0,0,0.03)', padding: '80px 0', marginTop: '40px' }}>
                <div className="container">
                    <div className="row" style={{ alignItems: 'center' }}>
                        <div className="col-xl-6 col-md-12 mb-4 mb-xl-0">
                            <div className="block-text pt-0" style={{ paddingRight: '30px' }} data-aos="fade-right" data-aos-duration="1000">
                                <h5 className="sub-title mb-20 text-black" style={{ fontSize: '50px' }}>Nuestra Filosofía</h5>
                                <p className="fs-21 mb-33 text-black">
                                    Nuestra misión es brindar un espacio donde los viajeros del mundo entero puedan conectarse, descansar y sentirse como en casa mientras descubren la magia de Tucumán.
                                </p>
                                <ul className="mb-4 text-black" style={{ listStyle: 'none', padding: 0 }}>
                                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                        <i className="fa fa-check" style={{ marginRight: '15px', color: '#ff5a5f', fontSize: '24px' }}></i>
                                        <p className="fs-21 mb-0">Comunidad y ambiente social</p>
                                    </li>
                                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                        <i className="fa fa-check" style={{ marginRight: '15px', color: '#ff5a5f', fontSize: '24px' }}></i>
                                        <p className="fs-21 mb-0">Comodidad y accesibilidad para todos</p>
                                    </li>
                                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                        <i className="fa fa-check" style={{ marginRight: '15px', color: '#ff5a5f', fontSize: '24px' }}></i>
                                        <p className="fs-21 mb-0">Experiencias y actividades semanales</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="group-image" data-aos="fade-left" data-aos-duration="1000">
                                <img src={vission} alt="Rodex Hostel Visión" style={{ borderRadius: '20px', width: '100%', objectFit: 'cover', boxShadow: '0 15px 40px rgba(0,0,0,0.1)' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <About />
            <Action />
            <Footer />
        </div>
    );
}

export default Nosotros;